export default __webpack_public_path__ + "static/media/victory_item2.97113864.png";